module.exports = __webpack_public_path__ + "static/media/associates.f46bf7b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/associates.png
// module id = 3542
// module chunks = 3